import React from 'react';

export default function UnitSelect({ profile, onSelect, onLogout }) {
  return (
    <div style={styles.bg}>
      <div style={styles.card}>
        <div style={styles.header}>
          <div>
            <div style={styles.title}>Qual unidade?</div>
            <div style={styles.sub}>Olá, {profile.nome}. Selecione a unidade para visualizar.</div>
          </div>
          <span style={styles.adminPill}>Admin</span>
        </div>

        <div style={styles.opts}>
          <button style={styles.opt} onClick={() => onSelect('sinop')}>
            <div style={{ ...styles.icon, background: '#e8f1fb', color: '#185FA5' }}>S</div>
            <div>
              <div style={styles.optName}>Sinop</div>
              <div style={styles.optDesc}>Unidade Sinop — MT</div>
            </div>
          </button>
          <button style={styles.opt} onClick={() => onSelect('cv')}>
            <div style={{ ...styles.icon, background: '#eaf3de', color: '#3B6D11' }}>CV</div>
            <div>
              <div style={styles.optName}>Campo Verde</div>
              <div style={styles.optDesc}>Unidade Campo Verde — MT</div>
            </div>
          </button>
        </div>

        <div style={{ textAlign: 'center', marginTop: 20 }}>
          <button style={styles.backBtn} onClick={onLogout}>← Sair</button>
        </div>
      </div>
    </div>
  );
}

const styles = {
  bg: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: '#f5f4f0',
  },
  card: {
    background: '#fff',
    borderRadius: 14,
    border: '0.5px solid #e0ddd6',
    padding: '36px 32px',
    width: 360,
  },
  header: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    marginBottom: 24,
  },
  title: {
    fontSize: 20,
    fontWeight: 600,
    color: '#1a1a18',
    fontFamily: '"DM Sans", sans-serif',
    marginBottom: 4,
  },
  sub: {
    fontSize: 13,
    color: '#888',
    fontFamily: '"DM Sans", sans-serif',
  },
  adminPill: {
    background: '#eeedfe',
    color: '#534AB7',
    fontSize: 11,
    padding: '3px 10px',
    borderRadius: 20,
    fontWeight: 500,
    fontFamily: '"DM Sans", sans-serif',
    whiteSpace: 'nowrap',
  },
  opts: { display: 'flex', flexDirection: 'column', gap: 10 },
  opt: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    padding: '14px 16px',
    border: '0.5px solid #e0ddd6',
    borderRadius: 9,
    cursor: 'pointer',
    background: '#fff',
    textAlign: 'left',
    width: '100%',
    transition: 'border-color .15s',
  },
  icon: {
    width: 36,
    height: 36,
    borderRadius: 8,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 13,
    fontWeight: 600,
    flexShrink: 0,
    fontFamily: '"DM Mono", monospace',
  },
  optName: {
    fontSize: 14,
    fontWeight: 500,
    color: '#1a1a18',
    fontFamily: '"DM Sans", sans-serif',
  },
  optDesc: {
    fontSize: 12,
    color: '#888',
    fontFamily: '"DM Sans", sans-serif',
  },
  backBtn: {
    background: 'none',
    border: '0.5px solid #e0ddd6',
    borderRadius: 7,
    padding: '6px 14px',
    fontSize: 12,
    cursor: 'pointer',
    color: '#666',
    fontFamily: '"DM Sans", sans-serif',
  },
};
